import { createAction, props } from '@ngrx/store';
import {
  BestMatchingProfileListItemResponse,
  CreateRequest,
  CustomerAssignmentFilterListsResponse,
  CustomerDepartmentResponse,
  CustomerInquiryListItemResponse,
  DefaultDeliveryTimeListItemResponse,
  InquiryCreateRequest,
  InquiryDeclineRequest,
  InquiryDocumentResponse,
  InquiryOfferCreateRequest,
  InquiryOfferDeclineRequest,
  InquiryOfferPositionRequest,
  InquiryOfferUpdateRequest,
  InquiryResponse,
  MetaPagination,
  OffersCountResponse,
  PspBranchShortInfoResponse,
  QualificationPricingResponse,
  RevocationRequest,
  SendImmediatelyRequest,
  SurchargeListItemResponse,
  UpdateRequest2,
} from '../../../api';
import { BaseWeekDays, BaseInquiryShiftsWithFlexType } from '../../modules/inquiry/_enums/base-inquiry.enum';
import {
  BaseStaffRequestFormInterface,
  NewInquiryFormInterface,
} from '../../modules/inquiry/_interfaces/base-inquiry.interface';
import { BaseInquiryCandidateInterface } from '../../modules/inquiry/_interfaces/base-inquiry-candidate.interface';
import { BasePspInquiryOfferInterface } from '../../modules/inquiry/_interfaces/base-psp-inquiry-offer.interface';
import {
  BaseCustomerInquiryOfferInterface,
  BaseCustomerOfferBubbleSelectPayload,
} from '../../modules/inquiry/_interfaces/base-cusomer-inquiry-offer.interface';
import {
  ShiftPlanCalendarDateInterface,
  ShiftPlanCalendarRangeInterface,
  SimilarInquiriesPayloadInterface,
} from '../../modules/inquiry/_interfaces/base-shift-plan.interface';
import { FormGroup } from '@angular/forms';
import { FormRawValue } from '../../modules/inquiry/_interfaces/base-form.interface';
import { BaseInquiryOffersInterface } from '../../modules/inquiry/_interfaces/base-inquiry-offers.interface';
import { BaseInquiryBestCandidatesPayloadInterface } from '../../modules/inquiry/_interfaces/base-inquiry-best-candidates-payload.interface';
import { BaseInquiryListPayloadInterface } from '../../modules/inquiry/_interfaces/base-inquiry-list-payload.interface';
import { BaseCustomerInquiryOffersListPayloadInterface } from '../../modules/inquiry/_interfaces/base-customer-inquiry-offers-list-payload.interface';
import { BaseInquiriesPayloadInterface } from '../../modules/inquiry/_interfaces/base-inquiries-payload.interface';
import { InquiryCreateRequestExtended } from '../../modules/inquiry/_models/base-inquiry-dates-form';
import { BaseDeliveryTimeListItemExtendedInterface } from '../../modules/inquiry/_interfaces/base-delivery-time-list-item-extended.interface';
import { UserShortInfoNameType } from '../../modules/candidates/_types/base-user-full-name.type';
import { BaseInquiryDocumentToUploadInterface } from '../../modules/inquiry/_interfaces/base-inquiry-document-to-upload.interface';

export const getInquiries = createAction(
  '[Inquiry] Get inquiries',
  props<{
    payload: BaseInquiriesPayloadInterface;
  }>()
);
export const loadInquiries = createAction('[Inquiry] Load inquiries', props<{ payload: any }>());
export const successLoadInquiries = createAction('[Inquiry] Success load inquiries');
export const errorLoadInquiries = createAction('[Inquiry] Error load inquiries');

export const getPSPInquiries = createAction(
  '[Inquiry] Get psp inquiries',
  props<{
    payload: BaseInquiryListPayloadInterface;
  }>()
);

// create inquiry
export const createInquiry = createAction(
  '[Inquiry] Create inquiry',
  props<{
    payload: {
      data: InquiryCreateRequestExtended;
      needsInquiryListUpdate?: boolean;
      callback?: (inquiryId: number) => void;
    };
  }>()
);
export const successCreateInquiry = createAction('[Inquiry] Success create inquiry ');
export const errorCreateInquiry = createAction('[Inquiry] Error create inquiry');
export const clearInquiryCustomerData = createAction('[Inquiry] clear inquiry customer data');

export const fetchDepartment = createAction('[Inquiry] Fetch department', props<{ payload: number }>());
export const loadDepartment = createAction(
  '[Inquiry] Load department',
  props<{ payload: CustomerDepartmentResponse }>()
);
export const loadDepartmentSuccess = createAction('[Inquiry] Load department success');
export const loadDepartmentError = createAction('[Inquiry] Load department error');
export const resetDepartment = createAction('[Inquiry] Reset department');

// PSP Inquiry
export const loadPSPInquiry = createAction('[Inquiry] Load PSP inquiry', props<{ payload: number }>());
export const setPSPInquiry = createAction(
  '[Inquiry] Set PSP inquiry',
  props<{ payload: InquiryResponse & { weekdays: Record<BaseWeekDays, boolean> } }>()
);
export const successPSPInquiry = createAction('[Inquiry] Success PSP inquiry');
export const errorPSPInquiry = createAction('[Inquiry] Error PSP inquiry');

// Responsible User list
export const loadResponsibleUserList = createAction(
  '[Inquiry] Load Responsible User list',
  props<{ payload: number }>()
);
export const setResponsibleUserList = createAction(
  '[Inquiry] Set Responsible User list',
  props<{ payload: UserShortInfoNameType[] }>()
);
export const successResponsibleUserList = createAction('[Inquiry] Success Responsible User list');
export const errorResponsibleUserList = createAction('[Inquiry] Error Responsible User list');

// PSP Customer Qualification price
export const loadPSPCustomerQualificationPrice = createAction(
  '[Inquiry] Load PSP Customer Qualification price',
  props<{ payload: { customer: number; qualification: number; locationId: number } }>()
);
export const setPSPCustomerQualificationPrice = createAction(
  '[Inquiry] Set PSP Customer Qualification price',
  props<{ payload: QualificationPricingResponse }>()
);
export const successPSPCustomerQualificationPrice = createAction('[Inquiry] Success PSP Customer Qualification price');
export const errorPSPCustomerQualificationPrice = createAction('[Inquiry] Error PSP Customer Qualification price');

// Surcharges for create offer popup
export const setSurchargesForOfferCreation = createAction(
  '[Inquiry] Set Surcharges for Create Inquiry Offer',
  props<{ payload: SurchargeListItemResponse[] }>()
);

// Create Inquiry Offer
export const createInquiryOffer = createAction(
  '[Inquiry] Create Inquiry Offer',
  props<{ payload: { inquiry: number; body: InquiryOfferCreateRequest; isUnlimited?: boolean } }>()
);

// Update Inquiry Offer
export const updateInquiryOffer = createAction(
  '[Inquiry] Update Inquiry Offer',
  props<{
    payload: { offer: number; inquiry: number; body: InquiryOfferUpdateRequest };
  }>()
);

export const loadCustomerInquiry = createAction('[Inquiry] Load customer inquiry', props<{ payload: number }>());
export const setCustomerInquiry = createAction('[Inquiry] Set customer inquiry', props<{ payload: InquiryResponse }>());
export const successCustomerInquiry = createAction('[Inquiry] Success customer inquiry');
export const errorCustomerInquiry = createAction('[Inquiry] Error customer inquiry');

export const acceptOffer = createAction(
  '[Inquiry] Accept offer',
  props<{
    payload: {
      inquiry: number;
      offer: number;
      offerPositions: InquiryOfferPositionRequest[];
    };
  }>()
);
export const acceptOfferSuccessful = createAction('[Inquiry] Accept offer successful');

// Download PspCustomer Contract Template File
export const downloadPspCustomerContractTemplateFile = createAction(
  '[Inquiry] Download PspCustomer Contract Template File',
  props<{ payload: number }>()
);
export const downloadPspCustomerContractTemplateFileSuccess = createAction(
  '[Inquiry] Download PspCustomer Contract Template File success'
);
export const downloadPspCustomerContractTemplateFileError = createAction(
  '[Inquiry] Download PspCustomer Contract Template File error'
);

// Download Customer contract document
export const downloadCustomerContractDocument = createAction('[Inquiry] Download Customer contract document file');
export const downloadCustomerContractDocumentSuccess = createAction(
  '[Inquiry] Download Customer contract document file success'
);
export const downloadCustomerContractDocumentError = createAction(
  '[Inquiry] Download Customer contract document file error'
);

// Download offer document
export const downloadInquiryOfferDocument = createAction(
  '[Inquiry] Download offer document file',
  props<{
    payload: { inquiry: number; offer: number; documentUuid: string; documentType: string; openInModal: boolean };
  }>()
);
export const downloadInquiryOfferDocumentSuccess = createAction('[Inquiry] Download offer document file success');
export const downloadInquiryOfferDocumentError = createAction('[Inquiry] Download offer document file error');
export const clearDownloadInquiryOfferDocumentFile = createAction('[Inquiry] Clear download inquiry offer file');

export const setDownloadInquiryOfferDocumentFile = createAction(
  '[Inquiry] Set Download offer document file',
  props<{ payload: { document: Blob } }>()
);

// Decline offer customer
export const declineOfferCustomer = createAction(
  '[Inquiry] Decline offer customer',
  props<{
    payload: {
      offer: number;
      inquiry: number;
      body: InquiryOfferDeclineRequest;
      isCustomerOffersList?: boolean;
    };
  }>()
);
export const declineOfferCustomerSuccess = createAction('[Inquiry] Offer declined successfully');
export const declineOfferCustomerError = createAction('[Inquiry] Offer not declined because of error');

// Decline inquiry (PSP side) — permanent, per branch of the logged-in user
export const declineInquiry = createAction(
  '[Inquiry] Decline inquiry',
  props<{ payload: { inquiry: number; body: InquiryDeclineRequest } }>()
);
export const declineInquirySuccess = createAction('[Inquiry] Decline inquiry success');
export const declineInquiryError = createAction('[Inquiry] Decline inquiry error');

// Revoke/Remove offer
export const revokeOffer = createAction(
  '[Inquiry] Revoke offer',
  props<{
    payload: {
      inquiry: number;
      offer: number;
      body: RevocationRequest;
      isOffersAndBookings?: boolean;
    };
  }>()
);
export const revokeOfferSuccess = createAction('[Inquiry] Revoke offer successfully');
export const revokeOfferError = createAction('[Inquiry] Revoke offer error');

// Update inquiry status
export const updateInquiryStatus = createAction(
  '[Inquiry] Update inquiry status',
  props<{
    payload: {
      inquiry: number;
      status: 1 | 2 | 3;
      closedNote?: string;
      loadUnpublishedInquiries?: boolean;
      isDashboard?: boolean;
      callback?: () => void;
    };
  }>()
);
export const updateInquiryStatusSuccess = createAction('[Inquiry] Update inquiry status success');
export const updateInquiryStatusError = createAction('[Inquiry] Update inquiry status error');

// Update inquiry
export const updateCustomerInquiry = createAction(
  '[Inquiry] Update customer inquiry',
  props<{ payload: { inquiry: number; body: InquiryCreateRequestExtended; callback?: () => void } }>()
);
export const updateCustomerInquirySuccess = createAction('[Inquiry] Update customer inquiry success');
export const updateCustomerInquiryError = createAction('[Inquiry] Update customer inquiry error');

// Inquiry branches
export const loadInquiryBranches = createAction(
  '[Inquiry] Load inquiry branches',
  props<{ payload: { inquiry: number } }>()
);
export const setInquiryBranches = createAction(
  '[Inquiry] Set inquiry branches',
  props<{ payload: PspBranchShortInfoResponse[] }>()
);
export const successLoadInquiryBranches = createAction('[Inquiry] Success load inquiry branches');
export const errorLoadInquiryBranches = createAction('[Inquiry] Error load inquiry branches');

// Inquiry Candidates List
export const loadInquiryCandidatesList = createAction(
  '[Inquiry] Load inquiry candidates list',
  props<{
    payload: BaseInquiryBestCandidatesPayloadInterface;
  }>()
);
export const setInquiryCandidatesList = createAction(
  '[Inquiry] Set inquiry candidates list',
  props<{ payload: BaseInquiryCandidateInterface[] }>()
);

export const addInquiryCandidatesPage = createAction(
  '[Inquiry] Add inquiry candidates page',
  props<{
    payload: {
      data: BaseInquiryCandidateInterface[];
      pagination: MetaPagination;
    };
  }>()
);

export const setInitialInquiryCandidatesList = createAction(
  '[Inquiry] Set initial inquiry candidates list',
  props<{
    payload: {
      data: BestMatchingProfileListItemResponse[];
      pagination: MetaPagination;
    };
  }>()
);

export const resetInquiryCandidatesItems = createAction('[Inquiry] Reset inquiry candidates items');
export const setInquiryCandidatesListSuccess = createAction('[Inquiry] Set inquiry candidates list success');
export const setInquiryCandidatesListError = createAction('[Inquiry] Set inquiry candidates list error');

// Shift Plan
export const shiftPlanCreateData = createAction(
  '[Inquiry] Shift plan inquiry create data',
  props<{
    payload: FormRawValue<FormGroup<BaseStaffRequestFormInterface>>;
  }>()
);

export const openInquiryInEditMode = createAction(
  '[Inquiry] Open inquiry in edit mode',
  props<{
    payload: {
      inquiry: InquiryResponse;
      similarInquiriesPayload: SimilarInquiriesPayloadInterface;
      copiedInquiryId?: number;
    };
  }>()
);

export const shiftPlanUpdateData = createAction(
  '[Inquiry] Shift plan update data',
  props<{
    payload: {
      data: FormRawValue<FormGroup<NewInquiryFormInterface>>;
      rangeId?: string;
    };
  }>()
);

export const setInquiryShiftViewRangeList = createAction(
  '[Inquiry] Set inquiry shift view range list',
  props<{
    payload: ShiftPlanCalendarRangeInterface[];
  }>()
);

export const setShiftPlanInquiryList = createAction(
  '[Inquiry] Set shift plan inquiry list',
  props<{
    payload: {
      list: ShiftPlanCalendarDateInterface[];
      formData: InquiryCreateRequest & { id?: number };
    };
  }>()
);

export const updateShiftPlanInquiryList = createAction(
  '[Inquiry] Update shift plan inquiry list',
  props<{
    payload: ShiftPlanCalendarDateInterface[];
  }>()
);

export const updateShiftPlanFormData = createAction(
  '[Inquiry] Update shift plan form data',
  props<{
    payload: InquiryCreateRequest & { id?: number };
  }>()
);

export const removeShiftPlanRange = createAction(
  '[Inquiry] Remove shift plan range',
  props<{
    payload: string;
  }>()
);

export const resetShiftPlanData = createAction('[Inquiry] Reset shift plan data');

// Similar inquiries
export const loadSimilarInquiries = createAction(
  '[Inquiry] Load similar inquiries',
  props<{
    payload: SimilarInquiriesPayloadInterface;
  }>()
);
export const setSimilarInquiries = createAction(
  '[Inquiry] Set similar inquiries',
  props<{ payload: CustomerInquiryListItemResponse[] }>()
);
export const successSetSimilarInquiries = createAction('[Inquiry] Success set similar inquiries');
export const errorSetSimilarInquiries = createAction('[Inquiry] Error set similar inquiries');

// PSP Inquiry Offers
export const loadPspInquiryOffersList = createAction(
  '[Inquiry] Load inquiry psp offers list',
  props<{
    payload: BaseInquiryOffersInterface;
  }>()
);
export const setPspInquiryOffersList = createAction(
  '[Inquiry] Set inquiry psp offers list',
  props<{ payload: BasePspInquiryOfferInterface[] }>()
);
export const addPspInquiryOffersListNextPage = createAction(
  '[Inquiry] Add inquiry psp offers next page items',
  props<{ payload: BasePspInquiryOfferInterface[] }>()
);

export const setPspInquiryOffersListPagination = createAction(
  '[Inquiry] Set inquiry psp offers list pagination',
  props<{ payload: MetaPagination }>()
);

export const setPspInquiryOffersCount = createAction(
  '[Inquiry] Set inquiry psp offers count',
  props<{ payload: OffersCountResponse }>()
);

export const setPspInquiryOffersListSuccess = createAction('[Inquiry] Set inquiry psp offers list success');
export const setPspInquiryOffersListError = createAction('[Inquiry] Set inquiry psp offers list error');

// PSP Inquiry Offer selection
export const selectPspInquiryOffer = createAction(
  '[Inquiry] Select PSP inquiry offer',
  props<{ payload: { offerId: number } }>()
);

// Customer Inquiry Offers
export const loadCustomerInquiryOffersList = createAction(
  '[Inquiry] Load inquiry customer offers list',
  props<{
    payload: BaseCustomerInquiryOffersListPayloadInterface;
  }>()
);
export const setCustomerInquiryOffersList = createAction(
  '[Inquiry] Set inquiry customer offers list',
  props<{ payload: BaseCustomerInquiryOfferInterface[] }>()
);
export const addCustomerInquiryOffersListNextPage = createAction(
  '[Inquiry] Add inquiry customer offers list next page',
  props<{ payload: BaseCustomerInquiryOfferInterface[] }>()
);
export const setCustomerInquiryOffersFiltersAndPagination = createAction(
  '[Inquiry] Set inquiry customer offers filters and pagination',
  props<{ payload: { pagination: MetaPagination; filters?: CustomerAssignmentFilterListsResponse } }>()
);

export const setCustomerInquiryOffersListSuccess = createAction('[Inquiry] Set inquiry customer offers list success');
export const setCustomerInquiryOffersListError = createAction('[Inquiry] Set inquiry customer offers list error');
export const resetCustomerInquiryOffersList = createAction('[Inquiry] Reset inquiry customer offers list');

export const selectCustomerInquiryOffer = createAction(
  '[Inquiry] Select Customer inquiry offer',
  props<{ payload: { offerId: number } }>()
);

export const selectCustomerOfferBubble = createAction(
  '[Inquiry] Select customer offer bubble',
  props<{ payload: BaseCustomerOfferBubbleSelectPayload }>()
);

export const customerOfferFlexShiftsSelection = createAction(
  '[Inquiry] Select/deselect all flex shifts for customer offer',
  props<{ payload: { offerId: number } }>()
);

export const customerOfferFixedShiftsSelection = createAction(
  '[Inquiry] Select/deselect all fixed shifts by shift type for a customer offer',
  props<{ payload: { offerId: number; shiftType: BaseInquiryShiftsWithFlexType } }>()
);

export const customerOfferAllShiftsSelection = createAction(
  '[Inquiry] Select/deselect all flex and fixe shifts for customer offer',
  props<{ payload: { offerId: number; isShiftsDeselectionMode: boolean } }>()
);

export const customerInquiryOfferPreselection = createAction(
  '[Inquiry] Preselect/unselect customer inquiry offer',
  props<{ payload: { inquiry: number; offer: number; preselect: boolean; isCustomerOffersList?: boolean } }>()
);

export const successCustomerInquiryOfferPreselection = createAction(
  '[Inquiry] Preselect/unselect customer inquiry offer success'
);

export const errorCustomerInquiryOfferPreselection = createAction(
  '[Inquiry] Preselect/unselect customer inquiry offer error'
);

// default delivery time list
export const loadDefaultDeliveryTimeList = createAction(
  '[Inquiry] Load default delivery time list',
  props<{
    payload: number;
  }>()
);
export const setDefaultDeliveryTimeList = createAction(
  '[Inquiry] Set default delivery time list',
  props<{ payload: DefaultDeliveryTimeListItemResponse[] }>()
);
export const successDefaultDeliveryTimeList = createAction('[Inquiry] Success load default delivery time list');
export const errorDefaultDeliveryTimeList = createAction('[Inquiry] Error load default delivery time list');

// create a delivery time list
export const createCustomerDeliveryTimeList = createAction(
  '[Inquiry] Create customer delivery time list',
  props<{
    payload: {
      inquiryId: number;
      body: CreateRequest;
      callback?: () => void;
    };
  }>()
);
export const successCreateCustomerDeliveryTimeList = createAction(
  '[Inquiry] Success create customer delivery time list'
);
export const errorCreateCustomerDeliveryTimeList = createAction('[Inquiry] Error create customer delivery time list');

// Inquiry providers
export const loadInquiryProviders = createAction(
  '[Inquiry] Load inquiry providers',
  props<{ payload: { inquiryId: number } }>()
);
export const setInquiryProviders = createAction(
  '[Inquiry] Set inquiry providers',
  props<{ payload: BaseDeliveryTimeListItemExtendedInterface[] }>()
);
export const successInquiryProviders = createAction('[Inquiry] Success inquiry providers');
export const errorInquiryProviders = createAction('[Inquiry] Error inquiry providers');

// Send Inquiry Providers Immediately
export const sendInquiryProvidersImmediately = createAction(
  '[Inquiry] Send inquiry providers immediately',
  props<{ payload: { inquiry: number; body: SendImmediatelyRequest } }>()
);
export const sendInquiryProvidersImmediatelySuccess = createAction(
  '[Inquiry] Send inquiry providers immediately success'
);
export const sendInquiryProvidersImmediatelyError = createAction('[Inquiry] Send inquiry providers immediately error');

// Inquiry Document
// Upload new inquiry document file
export const uploadInquiryDocumentFile = createAction(
  '[Inquiry] Upload Inquiry Document File',
  props<{
    payload: {
      documentToUpload: BaseInquiryDocumentToUploadInterface;
      requestData: InquiryCreateRequestExtended;
      createInquiryCallback?: (inquiryId: number) => void;
      updateInquiryCallback?: () => void;
      inquiryId?: number;
    };
  }>()
);
export const uploadInquiryDocumentFileSuccess = createAction('[Inquiry] Success Upload Inquiry Document File');
export const uploadInquiryDocumentFileError = createAction('[Inquiry] Error Upload Inquiry Document File');

// Load inquiry document
export const loadInquiryDocument = createAction(
  '[Inquiry] Load Inquiry Document',
  props<{ payload: { inquiry: number; document: string } }>()
);
export const setInquiryDocument = createAction(
  '[Inquiry] Set Inquiry Document',
  props<{ payload: InquiryDocumentResponse }>()
);
export const resetInquiryDocument = createAction('[Inquiry] Reset Inquiry Document');
export const successLoadInquiryDocument = createAction('[Inquiry] Success Load Inquiry Document');
export const errorLoadInquiryDocument = createAction('[Inquiry] Error Load Inquiry Document');

// Update inquiry document
export const updateInquiryDocument = createAction(
  '[Inquiry] Update Inquiry Document',
  props<{ payload: { inquiry: number; document: string; body: UpdateRequest2 } }>()
);
export const updateInquiryDocumentSuccess = createAction('[Inquiry] Success Update Inquiry Document');
export const updateInquiryDocumentError = createAction('[Inquiry] Error Update Inquiry Document');

// Delete inquiry document
export const deleteInquiryDocument = createAction(
  '[Inquiry] Delete Inquiry Document',
  props<{ payload: { inquiry: number; document: string } }>()
);
export const deleteInquiryDocumentSuccess = createAction('[Inquiry] Success Delete Inquiry Document');
export const deleteInquiryDocumentError = createAction('[Inquiry] Error Delete Inquiry Document');

// Download inquiry document file
export const downloadInquiryDocumentFile = createAction(
  '[Inquiry] Download Inquiry Document File',
  props<{ payload: { document: string; documentType: string; inquiry: number; isPreview?: boolean } }>()
);
export const setDownloadedInquiryDocumentFile = createAction(
  '[Inquiry] Set Downloaded Inquiry Document File',
  props<{ payload: { document: Blob } }>()
);
export const clearDownloadedInquiryDocumentFile = createAction('[Inquiry] Clear Downloaded Inquiry Document File');
export const successDownloadInquiryDocumentFile = createAction('[Inquiry] Success Download Inquiry Document File');
export const errorDownloadInquiryDocumentFile = createAction('[Inquiry] Error Download Inquiry Document File');

// Copy inquiry document info to upload
export const copyInquiryDocumentInfoToUpload = createAction(
  '[Inquiry] Copy Inquiry Document Info To Upload',
  props<{ payload: { inquiry: number; document: string; documentName: string } }>()
);
export const successCopyInquiryDocumentInfoToUpload = createAction(
  '[Inquiry] Success Copy Inquiry Document Info To Upload'
);
export const errorCopyInquiryDocumentInfoToUpload = createAction(
  '[Inquiry] Error Copy Inquiry Document Info To Upload'
);
